import React from 'react'
import { getHexColor, OneColorIconProps } from '../utils'

export const CheckBoxBlankIcon: React.FC<OneColorIconProps> = ({ className, color = 'white', size = 32 }) => {
  const hexColor = getHexColor(color)

  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.83333 35C7.91667 35 7.13167 34.6739 6.47833 34.0217C5.82611 33.3683 5.5 32.5833 5.5 31.6667V8.33333C5.5 7.41667 5.82611 6.63167 6.47833 5.97833C7.13167 5.32611 7.91667 5 8.83333 5H32.1667C33.0833 5 33.8683 5.32611 34.5217 5.97833C35.1739 6.63167 35.5 7.41667 35.5 8.33333V31.6667C35.5 32.5833 35.1739 33.3683 34.5217 34.0217C33.8683 34.6739 33.0833 35 32.1667 35H8.83333ZM8.83333 31.6667H32.1667V8.33333H8.83333V31.6667Z"
        fill={hexColor}
      />
    </svg>
  )
}
